import type { ListAgent } from './model';
import { domain } from './utils';

export const addAgent = domain.event<ListAgent>();
export const updateAgent = domain.event<ListAgent>();
export const deleteAgent = domain.event<number>();
export const reset = domain.event<void>();
